export default function (theme) {
    return {
        root: {
            color: theme.palette.background.paper,
        },
        open: {
            backgroundColor: theme.palette.secondary.dark
        },
        avatar: {
            width: 50,
            height: 50,
            borderStyle: 'solid',
            borderWidth: 1,
            borderColor: theme.palette.secondary.dark,
            '@media (max-width:768px)': {
                width: '40px',
                height: '40px'
            },
        },
        avatarButton: {
            padding: theme.spacing(1)
        },
        menuItem: {
            color: `${theme.palette.background.paper} !important`
        },
        menuItemIcon: {
            color: 'rgba(255, 255, 255, 0.8)'
        },
        menuDivider: {
            color: theme.palette.background.paper,
            '&:focus': {
                outlineStyle: 'none',
            }
        },
        userNamePanel: {
            padding: 15,
            opacity: 0.8,
            userSelect: 'none',
            '&:focus': {
                outlineStyle: 'none',
            }
        },
        number: {
            color: theme.palette.background.paper
        }
    }
}